import React from 'react';
import PropTypes from 'prop-types';
// our components
import { Query } from 'components/common/Query';
import { PERMISSIONS_GROUP_QUERY } from 'components/Permission/List';
import WithPermission from 'components/User/WithPermission';
import Filter from './Filter';

/**
 * @description
 * Stateless component to handle user filters
 *
 * @param {Object} props - Component props.
 */
function UserFilterContainer(props) {
  const { showFilters, filter, appliedFilter } = props;
  return (
    <WithPermission
      alt={
        <Filter
          appliedFilter={appliedFilter}
          filter={filter}
          showFilters={showFilters}
          t={() => ''}
        />
      }
      allowPermissions={['list_group']}
    >
      <Query
        query={PERMISSIONS_GROUP_QUERY}
        variables={{}}
        notifyOnNetworkStatusChange
      >
        {({ data, loading }) =>
          !loading && (
            <Filter
              appliedFilter={appliedFilter}
              permissionsGroups={data ? data.permissionsGroups : null}
              filter={filter}
              showFilters={showFilters}
              t={() => ''}
            />
          )
        }
      </Query>
    </WithPermission>
  );
}

/**
 * UserFilterContainer PropTypes
 * @param appliedFilter - prop pass to Filter
 * @callback filter - prop pass to Filter
 * @callback showFilters - prop pass to Filter
 */

UserFilterContainer.propTypes = {
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  showFilters: PropTypes.func.isRequired,
};

export default UserFilterContainer;
